

export const DUMMY_PAYLOADS = [
    {
      is_open_source_pipeline: false, // or false
      sharepoint_url:"https://eyus.sharepoint.com/sites/AppleBankAndCitiPOC",
      sharepoint_path: "/sites/AppleBankAndCitiPOC/Shared Documents/General/AppleBanktest",
      product_name: "Loan",
      client_name: "Test Bank",
      engagement_name: "Loan File Review"
    }
  ];
